import React, { useState, useRef } from 'react';
import { IoCloudUploadOutline } from 'react-icons/io5';

const ThumbnailUpload = ({ initialImage, onFileSelect, height }) => {
    const [preview, setPreview] = useState(initialImage || null);
    const fileInputRef = useRef(null);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            // 1. Create local preview for the <img> tag
            const objectUrl = URL.createObjectURL(file);
            setPreview(objectUrl);

            // 2. Pass the raw file to the parent state
            onFileSelect(file);
        }
    };

    const handleCancel = () => {
        setPreview(null);
        onFileSelect(null); // Clear parent state
        if (fileInputRef.current) fileInputRef.current.value = ""; // Reset input
    };

    const triggerPicker = () => {
        fileInputRef.current.click();
    };

    return (
        <div className="thumbnail_cover" style={height ? {height: height} : null}>
            {/* Hidden File Input */}
            <input
                type="file"
                ref={fileInputRef}
                onChange={handleFileChange}
                style={{ display: 'none' }}
                accept="image/*"
            />

            <div className="thumbnail_contain">
                {preview ? (
                    <>
                        <img src={preview} alt="Preview" />
                        <button onClick={triggerPicker}>Re-Upload</button>
                        <button onClick={handleCancel}>Cancel</button>

                    </>
                ) : (
                    <>
                        <IoCloudUploadOutline />
                        <p>Drop a file or click to upload</p>
                        <button onClick={triggerPicker}>Upload Image</button>
                    </>
                )}
            </div>
        </div>
    );
};

export default ThumbnailUpload;